var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"header-img",attrs:{"src":require("../../admin/assets/images/logo2.png")}}),_c('el-divider',{attrs:{"direction":"vertical"}}),_c('p',[_vm._v("认证考试")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }